import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { getPaginationPayload } from '~/utils/pagination';
import { IHospitalStore, IThunkGetMoreHospitalEvents } from '../types';

const onGetMoreHospitalEvents: IThunkGetMoreHospitalEvents = thunk(
  // @ts-ignore
  async ({ setMoreHospitalEvents }, payload, { getState }) => {
    const localState = getState() as IHospitalStore;
    const paginationPayload = getPaginationPayload(localState.pagination);

    const { data } = await api.hospital.getEventsList({
      ...payload,
      ...paginationPayload,
    });

    setMoreHospitalEvents(data ?? []);
  },
);

export default onGetMoreHospitalEvents;
